export function scrollToSection(label) {
  const id = label.toLowerCase().replace(/ /g, "-");
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
}
